const removeAccents = (str, withNormalize = true) => {
  if (withNormalize) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036F]/g, '');
  }

  let stringSemAcentos = str || '';
  const mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g,
  };

  for (const letra in mapaAcentosHex) {
    if (mapaAcentosHex.Object.prototype.hasOwnProperty.call(letra)) {
      const expressaoRegular = mapaAcentosHex[letra];
      stringSemAcentos = stringSemAcentos.replace(expressaoRegular, letra);
    }
  }

  return stringSemAcentos;
};
const slug = (text, removeColon = false) => {
  text = removeAccents(text).trim().replace(/<br\/?>/g, '');
  const regexSpace = /[ ]{1}/g;
  if (regexSpace.test(text) === true) {
    text = text
      .split(' ')
      .filter((v) => v)
      .join('-');
  }
  if (removeColon) {
    return text.replace(/[.,:"“”()/?!@#$%^&*]/g, '').toLowerCase();
  }
  return text.replace(/[.,"“”()/?!@#$%^&*]/g, '').toLowerCase();
};

export { removeAccents, slug };
